export default __webpack_public_path__ + "static/media/totals_bg.b1b1494a.svg";